export const EXAMS_DOMAINS = [
    {id:1, value: 'Engineering'},
    {id:2, value: 'Management'},
    {id:3, value: 'Medical'},
    {id:4, value: 'Law'},
    {id:5, value: 'Animation'},
    {id:6, value: 'Media Journalism'},
    {id:7, value: 'Arts, Humanities and Social Sciences'},
    {id:8, value: 'Sciences'},
    {id:9, value: 'Commerce'},
    {id:10, value: 'Computer Application and IT'},
    {id:11, value: 'Pharmacy'},
    {id:12, value: 'Education'},
    {id:13, value: 'Hospitality and Tourism'},
    {id:14, value: 'Competition'},
    {id:51, value: 'Business and Management'},
    {id:52, value: 'Biology and Life Sciences'},
    {id:53, value: 'Test Certificate Category'},
    {id:54, value: 'Marketing'},
    {id:55, value: 'Finance and Accounting'},
    {id:56, value: 'Teaching and Academics'},
    {id:57, value: 'Lifestyle'},
    {id:58, value: 'Personal Development'},
    {id:59, value: 'Arts and Crafts'},
    {id:60, value: 'Design'},
    {id:61, value: 'Photography and Video'},
    {id:62, value: 'Languages'},
    {id:63, value: 'Engineering and Architecture'},
    {id:64, value: 'Health and Fitness'},
    {id:65, value: 'Humanities'},
    {id:66, value: 'IT & Software'},
    {id:67, value: 'Programming and Development'},
    {id:68, value: 'Health, Fitness and Medicine'},
    {id:69, value: 'Social Science'},
]